<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      title="编辑上架CPE"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="CPE供应商">
          <a-select
            v-decorator="['cpe_supplier_id', {
              rules: [{ required: true, message: '请选择CPE供应商' }]
            }]"
            show-search
            option-filter-prop="children"
            placeholder="请选择"
            :loading="loadingSupplierOptions"
            @change="handleSupplierChange"
          >
            <a-select-option
              v-for="opt in supplierOptions"
              :key="opt.id"
              :value="opt.id"
            >
              {{ opt.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="采购型号">
          <a-select
            v-decorator="['cpe_model_id', {
              rules: [{ required: true, message: '请选择采购型号' }]
            }]"
            show-search
            option-filter-prop="children"
            placeholder="请先选择供应商"
            :loading="loadingCpeModelOptions"
            :disabled="!selectedSupplierId"
          >
            <a-select-option
              v-for="opt in cpeModelOptions"
              :key="opt.id"
              :value="opt.id"
            >
              {{ formatModelOption(opt) }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="通讯方式">
          <a-select
            v-decorator="['comm_mode_id', {
              rules: [{ required: true, message: '请选择通讯方式' }]
            }]"
            show-search
            option-filter-prop="children"
            placeholder="请选择"
            :loading="loadingCommModeOptions"
          >
            <a-select-option
              v-for="opt in commModeOptions"
              :key="opt.id"
              :value="opt.id"
            >
              {{ opt.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="单价(元/台)">
          <a-input-number
            style="width: 100%"
            :min="0"
            :precision="2"
            :step="0.01"
            v-decorator="['unit_price', {
              rules: [{ required: true, message: '请输入单价' }]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findCommonTypeOptions } from '@/api/common_type'
import { findCpeSuppliers } from '@/api/cpe_supplier'
import { findCpeSupplierModelOptions } from '@/api/cpe_supplier_model'
import { findBaseCpeProductForm, updateBaseCpeProduct } from '@/api/base_cpe_product'

export default {
  name: 'EditBaseCpeProduct',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'base_cpe_product_edit' }),
      submitting: false,
      selectedSupplierId: 0,
      supplierOptions: [],
      cpeModelOptions: [],
      commModeOptions: [],
      loadingSupplierOptions: false,
      loadingCpeModelOptions: false,
      loadingCommModeOptions: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    Promise.all([
      this.fetchSupplierOptions(),
      this.fetchCommModeOptions()
    ]).then(() => {
      this.fetchFormData()
    })
  },
  methods: {
    formatModelOption(opt) {
      if (opt.display_model && opt.display_model !== opt.purchase_model) {
        return `${opt.purchase_model}（对外：${opt.display_model}）`
      }
      return opt.purchase_model || opt.name
    },

    fetchSupplierOptions() {
      this.loadingSupplierOptions = true
      return findCpeSuppliers({ per_page: 9999 }).then((res) => {
        if (res.code === 0) {
          this.supplierOptions = res.data
        }
        this.loadingSupplierOptions = false
      })
    },

    handleSupplierChange(supplierId) {
      this.selectedSupplierId = supplierId || 0
      this.form.setFieldsValue({ cpe_model_id: undefined })
      this.fetchCpeModelOptions(supplierId)
    },

    fetchCpeModelOptions(supplierId) {
      if (!supplierId) {
        this.cpeModelOptions = []
        return Promise.resolve()
      }
      this.loadingCpeModelOptions = true
      return findCpeSupplierModelOptions({
        cpe_supplier_id: supplierId,
        effective_only: true
      }).then((res) => {
        if (res.code === 0) {
          this.cpeModelOptions = res.data
        }
        this.loadingCpeModelOptions = false
      })
    },

    fetchCommModeOptions() {
      this.loadingCommModeOptions = true
      return findCommonTypeOptions('product_comm_mode').then((res) => {
        if (res.code === 0) {
          this.commModeOptions = res.data
        }
        this.loadingCommModeOptions = false
      })
    },

    fetchFormData() {
      findBaseCpeProductForm(this.id).then((res) => {
        if (res.code === 0) {
          this.selectedSupplierId = res.data.cpe_supplier_id
          this.fetchCpeModelOptions(res.data.cpe_supplier_id).then(() => {
            this.form.setFieldsValue(res.data)
          })
        }
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateBaseCpeProduct(this.id, values).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
